// Quiet hours, DNC, call caps.
import React from 'react';
import { NumberField, SwitchField, TextField } from './fields';

export default function ComplianceSection({ value, onChange }) {
  const set = (key) => (v) => onChange({ ...value, [key]: v });
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <SwitchField
          label="Enforce DNC"
          description="Skip leads on the do-not-call list."
          value={value.dnc_enforcement}
          onChange={set('dnc_enforcement')}
        />
        <SwitchField
          label="Include call recording disclosure"
          value={value.call_recording_disclosure}
          onChange={set('call_recording_disclosure')}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <NumberField
          label="Max call attempts / lead"
          value={value.max_call_attempts_per_lead}
          onChange={set('max_call_attempts_per_lead')}
          min={1}
          max={20}
        />
        <NumberField
          label="Cooldown hours"
          value={value.cooldown_hours}
          onChange={set('cooldown_hours')}
          min={0}
          max={720}
        />
        <TextField label="Timezone (IANA)" value={value.timezone} onChange={set('timezone')} />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TextField label="Quiet hours start (HH:MM)" value={value.quiet_hours_start} onChange={set('quiet_hours_start')} />
        <TextField label="Quiet hours end (HH:MM)" value={value.quiet_hours_end} onChange={set('quiet_hours_end')} />
      </div>
    </div>
  );
}
